import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { FundingClientDetailsView } from '../components/views/fundingClientDetailsView'
import { BackButton } from '../components/reusable'
import { Page } from '../ui'

function InsuranceAuditClientDetails() {
    return (
        <div className="insuranceAuditClientDetails">
            <Sidebar />
            <MainView>
                <Page>
                    <BackButton to="/insurance-audit" text="Back to Audit Cases" />
                    <FundingClientDetailsView auditMode />
                </Page>
            </MainView>
        </div>
    )
}

export default InsuranceAuditClientDetails
